import React from 'react';
import classNames from 'classnames';
var css = {
  "shown": "rui-8PlwS"
};
var TabContent = function TabContent(_ref) {
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? '' : _ref$children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$selected = _ref.selected,
    selected = _ref$selected === void 0 ? false : _ref$selected,
    _ref$dataAutId = _ref['data-aut-id'],
    dataAutId = _ref$dataAutId === void 0 ? 'tabContent' : _ref$dataAutId;
  var classes = [selected && css.shown, className];
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(classes),
    "data-aut-id": dataAutId
  }, children);
};
export default TabContent;